import ReconciliationStepTemplate from './ReconciliationStepTemplate.vue';
export default {
    props: {
        previousStep: {
            type: [Boolean, String],
            required: false,
            default: false,
        },
        nextStep: {
            type: [Boolean, String],
            required: false,
            default: false,
        },
        csv: {
            type: Array,
            required: true,
        },
        modelValue: {
            type: Object,
            required: true,
        },
        // idImport: {
        //     type: Number,
        //     required: true
        // }
    },
    computed: {
        idImport() {
            return this.$route.params.importid;
        },
    },
    methods: {
        checkPreviousSteps() {
            if (this.modelValue.template.date.columns.length === 0) {
                this.$emit('update-import-id', this.$route.params.importid);
                this.$emit('next', 'bankreconciliation-step2');
            }
        },
        checkMinColumns(key, min) {
            if (
                this.modelValue.template[key].columns.length > 0 &&
                this.modelValue.template[key].columns.length <= min
            ) {
                return true;
            } else {
                Push.error(this.$l10n.__('Vous devez sélectionner au minimum 1 colonne'), false);
                return false;
            }
        },
        checkLabelColumns() {
            // check on previous template if label use columns no longer exists
            const nbColumns = this.csv.lastItem.length;
            this.modelValue.template.label.columns = this.modelValue.template.label.columns.filter(
                (column) => column < nbColumns,
            );
        },
    },
    components: {
        ReconciliationStepTemplate,
    },
};
